import { faqLd } from "@/lib/schema";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export { faqLd };

export const FaqList = ({ faqs, testId = "faq" }) => (
  <Accordion type="single" collapsible className="border-t border-ink/15" data-testid={testId}>
    {faqs.map((f, i) => (
      <AccordionItem key={f.q} value={`f${i}`} className="border-b border-ink/15">
        <AccordionTrigger
          data-testid={`${testId}-trigger-${i}`}
          className="py-6 text-left font-display text-lg md:text-xl font-semibold text-ink hover:no-underline [&[data-state=open]]:text-sageDeep"
        >
          <span className="flex gap-4 md:gap-6">
            <span className="mt-1 text-xs font-sans font-bold text-ink/45">{String(i + 1).padStart(2, "0")}</span>
            {f.q}
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-6 pl-9 md:pl-12 text-base leading-relaxed text-ink/75">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
